if (!customElements.get('newsletter-form')) {
  class newsletterForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const newsletterFormType = this.dataset.newsletterFormType || 'customer';
      const newsletterFormId = this.dataset.formId || 'ContactFooter';
      const ctaText = this.dataset.ctaText || 'Subscribe';
      const vetFormFetchUrl = this.dataset.vetFormFetchUrl?.trim() || '';
      const vetFormToken = this.dataset.vetFormFetchToken?.trim() || '';
      const sourceCode =
        newsletterFormType === 'vet'
          ? 'VYPetivityVetPros'
          : 'SYGeneralPetivityInformation';
      const checkbox = this.querySelector('input[type="checkbox"]');
      const button = this.querySelector('button');
      const form = this.querySelector('form');
      const emailInput = form?.querySelector('input[type="email"]');
      const firstNameInput = form?.querySelector(
        'input[name="contact[first_name]"]',
      );
      const lastNameInput = form?.querySelector(
        'input[name="contact[last_name]"]',
      );
      const validationContainer = this.querySelector(
        '[data-opt-validation-message]',
      );
      const validationEmail = this.querySelector(
        '[data-opt-validation-message-email]',
      );
      const firstNameValidation = firstNameInput
        ?.closest('.newsletter-form__field')
        ?.parentElement?.querySelector(
          '[data-opt-validation-message-first-name]',
        );
      const lastNameValidation = lastNameInput
        ?.closest('.newsletter-form__field')
        ?.parentElement?.querySelector(
          '[data-opt-validation-message-last-name]',
        );
      const message =
        validationContainer?.dataset?.errorMessage ||
        'Please agree to the Terms and Conditions to continue.';

      form?.setAttribute('novalidate', '');

      if (button && checkbox && form) {
        button.addEventListener('click', (event) => {
          let isValid = true;
          let fieldFocused = false;

          if (
            !emailInput.validity.valid ||
            !emailInput.value.includes('.com')
          ) {
            validationEmail.innerHTML = `<span class="visually-hidden">Error:</span> <span>Please enter a valid email address (e.g., name@example.com). ${emailInput.validationMessage}</span>`;
            emailInput.focus();
            fieldFocused = true;
            isValid = false;
          } else {
            validationEmail.innerHTML = ``;
          }

          if (firstNameInput && !firstNameInput.value.trim()) {
            if (firstNameValidation)
              firstNameValidation.innerHTML = `<span class="visually-hidden">Error:</span> <span>Please enter your first name.</span>`;
            if (!fieldFocused) {
              firstNameInput.focus();
              fieldFocused = true;
            }
            isValid = false;
          } else if (firstNameInput && firstNameValidation) {
            firstNameValidation.innerHTML = '';
          }

          if (lastNameInput && !lastNameInput.value.trim()) {
            if (lastNameValidation)
              lastNameValidation.innerHTML = `<span class="visually-hidden">Error:</span> <span>Please enter your last name.</span>`;
            if (!fieldFocused) {
              lastNameInput.focus();
              fieldFocused = true;
            }
            isValid = false;
          } else if (lastNameInput && lastNameValidation) {
            lastNameValidation.innerHTML = '';
          }

          if (!checkbox.checked) {
            checkbox.setAttribute('aria-invalid', 'true');
            validationContainer.innerHTML = `<span class="visually-hidden">Error:</span> <span>${message}</span>`;
            if (!fieldFocused) {
              checkbox.focus();
            }
            isValid = false;
            return;
          }

          if (isValid) {
            button.type = 'submit';
            button.click();
          }
        });

        checkbox.addEventListener('change', () => {
          if (checkbox.checked) {
            checkbox.removeAttribute('aria-invalid');
            validationContainer.innerHTML = ``;
          }
        });
      }

      if (form && emailInput) {
        form.addEventListener('submit', () => {
          if (emailInput.value) {
            sessionStorage.setItem('newsletter_email', emailInput.value);
          }
          if (firstNameInput?.value) {
            sessionStorage.setItem(
              'newsletter_first-name',
              firstNameInput.value,
            );
          }
          if (lastNameInput?.value) {
            sessionStorage.setItem('newsletter_last-name', lastNameInput.value);
          }
        });
      }

      // Send data after (?customer_posted=true#ContactFooter)
      const url = new URL(window.location.href);
      const isNewsletterSuccess =
        url.searchParams.get('customer_posted') === 'true' &&
        url.hash === `#${newsletterFormId}`;

      if (isNewsletterSuccess) {
        const successWrapper = this.querySelector(
          '.newsletter-form__success-wrapper',
        );
        if (successWrapper) {
          setTimeout(() => {
            successWrapper.focus();
          }, 1000);
        }

        const submittedEmail = sessionStorage.getItem('newsletter_email');
        if (submittedEmail) {
          const submittedFirstName = sessionStorage.getItem(
            'newsletter_first-name',
          );
          const submittedlastName = sessionStorage.getItem(
            'newsletter_last-name',
          );

          if (analytics && newsletterFormType === 'customer') {
            let form_payload = {
              form: 'petivity_lead',
              email: submittedEmail,
              sourceCode: sourceCode,
              ...(submittedFirstName && {firstName: submittedFirstName}),
              ...(submittedlastName && {lastName: submittedlastName}),
            };

            analytics.identify({email: submittedEmail});
            analytics.track('lead_form', form_payload);
            console.log('lead_form - form_payload: ', form_payload);
          }

          if (newsletterFormType === 'vet') {
            const submittedlastName = sessionStorage.getItem(
              'newsletter_last-name',
            );

            const espPayload = {
              email: submittedEmail,
              lastName: submittedlastName || '',
              firstName: submittedFirstName || '',
              token: vetFormToken || '',
              sourceCode: {
                keyName: sourceCode,
              },
              optIn: true,
            };

            if (!vetFormFetchUrl) {
              console.warn(
                'VET form fetch URL is not configured. Skipping ESP request.',
              );
            } else {
              fetch(vetFormFetchUrl, {
                method: 'POST',
                headers: {
                  accept: 'application/json',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(espPayload),
              })
                .then(async (response) => {
                  const responseText = await response.text();
                  let responseData = responseText;

                  try {
                    responseData = responseText
                      ? JSON.parse(responseText)
                      : null;
                  } catch (error) {
                    responseData = responseText;
                  }

                  console.log('ESP /users response:', {
                    ok: response.ok,
                    status: response.status,
                    statusText: response.statusText,
                    data: responseData,
                  });
                })
                .catch((error) => {
                  console.error('ESP /users request failed:', error);
                });
            }
          }

          const formLocation =
            newsletterFormType === 'vet' ? 'vet_landing_page' : 'footer';
          const eventData = {
            event: 'newsletter_submit',
            event_params: {
              form_location: formLocation,
              form_name: 'newsletter_signup',
              form_type: 'newsletter',
              form_id: newsletterFormId,
              link_text: ctaText,
            },
          };
          ExecuteGA4Event(eventData);
          sessionStorage.removeItem('newsletter_email');
          sessionStorage.removeItem('newsletter_first-name');
          sessionStorage.removeItem('newsletter_last-name');
        }

        // Remove only the customer_posted parameter, keep the hash.
        url.searchParams.delete('customer_posted');
        const cleanedSearch = url.searchParams.toString();
        const newUrl =
          window.location.pathname +
          (cleanedSearch ? '?' + cleanedSearch : '') +
          url.hash;
        history.replaceState({}, '', newUrl);
      }
    }
  }

  customElements.define('newsletter-form', newsletterForm);
}
